import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ceb6479"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = {
  class: "sticky button-action-dice",
  style: {"z-index":"1200"}
}
const _hoisted_3 = {
  class: "absolute",
  style: {"left":"67%"}
}
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Roll Dice", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Done")
const _hoisted_7 = {
  class: "sticky button-action mx-auto",
  style: {"z-index":"1200","width":"70%"}
}
const _hoisted_8 = { class: "flex-1" }
const _hoisted_9 = { class: "py-2 px-3 sticky-div" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PiecePath = _resolveComponent("PiecePath")!
  const _component_Dice = _resolveComponent("Dice")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ClassicButton = _resolveComponent("ClassicButton")!
  const _component_ActionPan = _resolveComponent("ActionPan")!
  const _component_Board = _resolveComponent("Board")!
  const _component_SettingsPan = _resolveComponent("SettingsPan")!
  const _component_PlayerCard = _resolveComponent("PlayerCard")!
  const _component_PropertyModal = _resolveComponent("PropertyModal")!
  const _component_DealsModal = _resolveComponent("DealsModal")!
  const _component_BuildModal = _resolveComponent("BuildModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Board, {
      class: "relative inline-block",
      onShowPropertyDetails: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showPropDetails($event)))
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_PiecePath, {
          players: _ctx.players,
          class: "absolute",
          ref: "piecePathComponent",
          style: {"top":"6%","left":"5%"}
        }, null, 8, ["players"]), [
          [_vShow, !_ctx.toggleGrayScale]
        ]),
        _createVNode(_component_Dice, {
          class: "absolute",
          style: {"top":"30%","left":"23%"}
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!_ctx.rolledDice)
              ? (_openBlock(), _createBlock(_component_ClassicButton, {
                  key: 0,
                  color: '#be2e25',
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.RollDiceFunc()))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_Icon, {
                        icon: "ion:dice",
                        class: "mx-1 text-white",
                        style: {"font-size":"50px"}
                      }),
                      _hoisted_5
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_ClassicButton, {
                  key: 1,
                  color: '#01a9ea',
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.Done()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_ActionPan, {
            onDealBtnClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deals.show())),
            onBuildBtnClicked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.buildModal.show()))
          })
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_SettingsPan),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.players, (player, index) => {
          return (_openBlock(), _createBlock(_component_PlayerCard, {
            key: index,
            name: player.name,
            amount: player.bankBalance,
            image: player.link,
            active: index === _ctx.Players.getPlayerTurn
          }, null, 8, ["name", "amount", "image", "active"]))
        }), 128))
      ])
    ]),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        _createVNode(_component_PropertyModal, { ref: "property" }, null, 512)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        _createVNode(_component_DealsModal, { ref: "deals" }, null, 512)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        _createVNode(_component_BuildModal, { ref: "buildModal" }, null, 512)
      ]),
      _: 1
    })
  ]))
}